import { hdmgdjSteps } from "@/mocks/hdmgdj/steps";

export default function HdmgdjSteps() {
  return (
    <section id="hdmgdj-steps" className="w-full bg-background-100 py-16 md:py-24">
      <div className="hdmgdj-container">
        <div className="hdmgdj-reveal max-w-2xl">
          <span className="inline-flex items-center gap-2 text-secondary-700 text-[14px] font-label font-bold">
            <i className="ri-route-line text-lg" />
            使用流程
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-[30px] md:text-[44px] leading-tight">
            四步开启你的魔改之旅
          </h2>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8">
          {hdmgdjSteps.map((step, index) => (
            <div
              key={step.id}
              className="hdmgdj-reveal relative"
              style={{ transitionDelay: `${index * 70}ms` }}
            >
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-950 text-2xl shrink-0">
                  <i className={step.icon} />
                </span>
                <span className="font-heading text-[34px] leading-none text-background-300">
                  {step.no}
                </span>
              </div>
              <h3 className="mt-5 text-[17px] font-bold font-label text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-[14px] leading-7 text-foreground-600">{step.desc}</p>
              {index < hdmgdjSteps.length - 1 && (
                <span className="hidden lg:block absolute top-6 -right-4 text-background-400" aria-hidden="true">
                  <i className="ri-arrow-right-line text-xl" />
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}